/**
   * @ngdoc directive
   * @name adjust.directive:focus
   * @scope
   * @restrict A
   *
   * @description
   * Directive which recognize focus and blur events on input
   *
   * @param {Function} onFocus on focus callback
   * @param {Function} onBlur on blur callback
   *
   */
function focus() {
  'ngInject';
  return {
    restrict: 'A',
    scope: {},
    controller: 'FocusController',
    controllerAs: 'vm',
    bindToController: {
      onFocus: '&',
      onBlur: '&'
    }
  };
}

/**
   * @ngdoc controller
   * @name adjust.controller:FocusController
   *
   * @description
   * All the functionality of the {@link adjust.directive:focus focus} directive
   *
   */
function FocusController($element, $timeout, Helper) {
  'ngInject';
  var vm = this;
  var _tid;

  $element.on('focus', _handleFocus);
  $element.on('blur', _handleBlur);
  $element.on('$destroy', _handleDestroy);

  /**
   * @ngdoc method
   * @name _handleFocus
   * @methodOf adjust.controller:FocusController
   *
   * @description
   * Trigger callback on input focus
   *
   * @private
   */
  function _handleFocus() {

    if (!angular.isFunction(vm.onFocus)) { return; }

    $timeout(function() {
      vm.onFocus();
    });

  }

  /**
   * @ngdoc method
   * @name _handleBlur
   * @methodOf adjust.controller:FocusController
   *
   * @description
   * Trigger callback on input blur
   *
   * @private
   */
  function _handleBlur() {

    if (!angular.isFunction(vm.onBlur)) { return; }

    Helper.destroyTid(_tid);

    _tid = $timeout(vm.onBlur, 200);

  }

  /**
   * @ngdoc method
   * @name _handleDestroy
   * @methodOf adjust.controller:FocusController
   *
   * @description
   * Handle destroy, unbind events and destroy timeout
   *
   * @private
   */
  function _handleDestroy() {

    $element.off('focus', _handleFocus);
    $element.off('blur', _handleBlur);
    Helper.destroyTid(_tid);

  }
}

export { FocusController, focus };
